import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const StyledKey = styled.span`
  &,
  & > span {
    font-size: 1rem;
    font-weight: 700;
    color: ${({ theme }) => theme.labelColor};
  }
`;

export const StyledQuestionCircle = styled(QuestionCircleOutlined)`
  font-size: 10px;
  align-self: center;
  grid-column-start: 2;
  grid-column-end: 2;
`;

export const TruncatedTextGrid = styled.div`
  display: grid;
  place-items: stretch;
  grid-template-columns: auto 10px 10px;
  column-gap: 5px;
`;

export const TruncatedText = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  grid-column-start: 1;
  grid-column-end: 1;
`;

export const DamageNumberText = styled.span`
  font-family: monospace;
`;

export const NoneText = styled.em`
  color: ${({ theme }) => theme.noneTextColor};
`;
